export const CANCEL = 'Cancel';
export const COLLAPSE_ALL = 'Collapse All';
export const EXPAND_ALL = 'Expand All';
export const TAKING_LONG_TIME = 'Taking a long time...';
